import { Button, Typography } from '@braskai/ui-kit';

import { Stack } from '@mui/material';

type EmailConsentViewProps = {
  isConsenting: boolean;
  isDeclining: boolean;
  isLoggingOut: boolean;

  onConsent: () => void;
  onDecline: () => void;
};

export const EmailConsentView = ({
  isConsenting,
  isDeclining,
  isLoggingOut,

  onConsent,
  onDecline,
}: EmailConsentViewProps) => {
  const isDisabled = isLoggingOut || isConsenting || isDeclining;

  return (
    <>
      <Stack gap={8}>
        <Typography variant="body-1-md">Do you want to stay updated on our latest features?</Typography>
        <Typography color="grey.500" variant="body-2">
          Click 'Yes' to get useful updates by email
        </Typography>
      </Stack>

      <Stack direction="row" gap={12}>
        <Button
          disabled={isDisabled}
          isLoading={isDeclining}
          size="xl"
          variant="outlined"
          fullWidth
          onClick={onDecline}
        >
          {isDeclining ? 'Saving...' : 'No'}
        </Button>

        <Button disabled={isDisabled} isLoading={isConsenting} size="xl" fullWidth onClick={onConsent}>
          {isConsenting ? 'Saving...' : 'Yes'}
        </Button>
      </Stack>
    </>
  );
};
